import { render, staticRenderFns } from "./TextWithLabel.vue?vue&type=template&id=10362e10"
import script from "./TextWithLabel.vue?vue&type=script&lang=js"
export * from "./TextWithLabel.vue?vue&type=script&lang=js"
import style0 from "./TextWithLabel.vue?vue&type=style&index=0&id=10362e10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports